import * as React from 'react';
import { GlobalConfig } from '../../../sdk/model';
import { useAppSelector } from '../../../app/hooks';
import ManageUserGroup from '../../util/ManageUserGroup';
import { configApi } from '../../../adapters/APIExporter';
import { useDispatch } from 'react-redux';
import { setGlobalConfigDataLoad } from '../../../slices/globalConfigDataLoad';

function SysAdmins() {
  const dispatch = useDispatch();
  const globalConfig: GlobalConfig = useAppSelector((state) => state.globalConfigDataLoad);
  
  function submitChanges(updatedAdmins) {
    const newGlobalConfig = {...globalConfig}
    newGlobalConfig.adminUsers = updatedAdmins;
    configApi.setGlobalConfig(newGlobalConfig).then(() => {
      dispatch(setGlobalConfigDataLoad(newGlobalConfig));
    })
  }
  
  return <ManageUserGroup title="Sys Admin(s)" initialUsers={globalConfig.adminUsers!} omittedUsers={[]} submitChanges={submitChanges} autosubmit={false} />
}

export default SysAdmins;
